import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'app-rating-score-selector',
  templateUrl: './rating-score-selector.component.html',
  styleUrls: ['./rating-score-selector.component.scss']
})
export class RatingScoreSelectorComponent implements OnInit {

  @Output() scoreSelected: EventEmitter<number> = new EventEmitter();
  @Input() questionId: number;

  public levels: ILevels[];
  public selected: number;

  constructor() { 
  }

  ngOnInit() {
    console.log('entro al selector ', this.questionId);
  }

  /*getRange(range: number) : number[] {
    return Array.from({length: range}, (_, n) => n);
    
  }/*/
  getRange(questionId: number): number[] {
    if (questionId === 7) {
      return Array.from({ length: 11 }, (_, i) => i); // [0, 1, ..., 10]
    } else {
      return Array.from({ length: 10 }, (_, i) => i + 1); // [1, 2, ..., 10]
    }
  }
   

  selectScore(value: number) : void {
    this.selected = value
    this.scoreSelected.emit(value);
  }
  

}

interface ILevels {

}
